<template lang="pug"> 
  dialog-format(
    v-model='dialog'
    :title="$t('create-template-number')"
    :submitstatus='submitstatus'
    @addRow='addRow'
    @submit='saveSet'
  )
    v-form(ref="form" @submit.prevent) 
      v-row
        v-col(cols=12)
          h4 {{ $t('label.template-number-name') }}
          n-text-field-no-space.py-2(
            v-model='nameSet'
            :placeholder="$t('placeholder.template-number')" 
            :rules="templateNumberNameRules"
          )
      template(
        v-for='(temp,i) in items'
      )
        v-row(
          :key='i'
        )
          v-col
            b {{ $t('set-number-group') }} {{ i+1 }}
          v-col.text-end
            a.red--text(@click='removeRow(i)') {{ $t('remove') }}
        v-row
          v-col(cols=4) {{ $t('set-number') }} 
          v-col(align="end" cols=8) 
            v-select(
              v-model='temp.number_type'
              dense
              outlined
              return-object
              item-text='name'
              hide-details="auto"
              :items='numberType'
              :rules="templateNumberTypeRules"
              :label="$t('label.select-number')"
              @input='resetValue(i)'
            ) 
          v-col(cols=4) {{ $t('enter-number') }}
          v-col(align="end" cols=8)
            n-number-field-specific(
              v-model='temp.number'
              hide-details="auto"
              :label="$t('label.number')"
              :rules='templateNumberValueRules'
              @keydown='checkLimitNumber($event,i)'
            )
</template>
<script>
import { numberTemplate as apiNumberTemplate } from '@/apis' 
import DialogFormat from './dialogFormat'
import validate from '@/mixins/Validations'

export default { 
  components:{
    DialogFormat
  }, 
  mixins: [validate],
  data () {
    return {
      dialog : false,
      nameSet : null, 
      items :[], 
      submitstatus:false
    }
  }, 
  computed : {
    numberType () { 
      return this.$store.getters['templateNumberType/GETTERS_TEMPLATENUMBER_TYPE']
    }
  },  
  methods : { 
    async loadNumberType () { 
      await this.$store.dispatch('templateNumberType/ACTION_TEMPLATENUMBER_TYPE')
    },
    checkLimitNumber (evt,index) {   
      let value = this.items[index]
      if(
        !value.number_type.id 
        || value.number.length >= value.number_type.digit
        || evt.key === '-'
      ){ 
        if (evt.keyCode !== 8 && evt.keyCode !==46 ) { 
          evt.preventDefault()
          return
        }
      }  
    },

    resetValue (value){   
      this.items[value].number = null 
    },

    resetForm () { 
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },

    async open () {
      this.dialog = true
      await this.loadNumberType()
      this.resetForm()
    },

    addRow (){  
      this.items.push({number_type: {
          id:null,
          name:null,
          digit:null
      }, number:null}); 
    },

    removeRow (index){
      this.items.splice(index,1);
    },

    async saveSet (){ 
      this.$ga.event('Submit', 'CreateTemplateNumber', 'TemplateNumberPage','' )  
      if (this.$refs.form.validate()) {  

        let numbers = this.items.map(element=>{
          return {
            number:element.number,
            number_type_id :element.number_type.id
          }
        }) 

        let params = {
          name:this.nameSet,
          numbers:numbers
        }

        this.submitstatus = true
        const [err,,message] = await apiNumberTemplate.create(params)
        this.submitstatus = false
        
        if(err) {
          this.$alert('',err,'warning') 
          return
        }

        this.resetForm()
        this.dialog = false  
        this.$alert('',message,'success')
        this.$emit('submit')   
      }     
    },
  }
}
</script> 